// extracted by mini-css-extract-plugin
module.exports = {"buttonHoc":"ButtonHoc_buttonHoc__J5WJV"};